import { combineReducers } from 'redux';
import mainReducer from './reducers/main-reducer';
import partnerReducer from './reducers/select-partner-reducer';
// import signUpReducer from './reducers/signUp-reducer';

export default combineReducers({
  mainReducer,
  partnerReducer,
  // signUpReducer,
});



// WEBPACK FOOTER //
// ./src/app/stores/marketing-materials/reducer.js